import React from 'react'

function Mtab1() {
  return (
    <div>



<b>Own Goods vehicles insurance </b>– This is for the individuals, business firms who use commercial vehicle to transport their own goods which form part of the business.

<br></br><b>General Cartage vehicles insurance</b> – This is for the individuals, business firms who use commercial vehicle for hire and reward.

<br></br><b>What is covered: </b>
<ul className="list-disc list-inside">

<li>Vehicle damages as a result of an accident</li>
<li>Theft of the vehicle</li>
<li>Damage to vehicle due to accidental fire</li>
<li>Damage of property belonging to third parties</li>
<li>Bodily harm to third parties</li>
<li>Damage to car accessories that had been declared when the policy was bought</li>
<li>Consequential Legal fees incurred with permission from the insurer.</li>
</ul>





    </div>
  )
}

export default Mtab1